
<template>

  <div class="box">
    <Banner :banner-h="bannerH" :banner-img="bannerImg"></Banner>

    <el-tabs v-model="activeName" @tab-click="handleClick" >
      <el-tab-pane label="智能门禁平台" name="entranceGuard"></el-tab-pane>
      <el-tab-pane label="智能展柜平台" name="under"></el-tab-pane>
      <el-tab-pane label="售后服务平台" name="aft"></el-tab-pane>
    </el-tabs>

    <router-view></router-view>

  </div>

</template>

<script >

import Banner from "@/components/banner.vue";
export default {
  name: "softwarePlatform",
  components: {Banner},
  data() {
    return{
      bannerH: "软件平台",
      bannerImg: require("@/assets/img/banner-bg/banner-data.png"),
      activeName: "entranceGuard",
      setsize: "24px",
      breadcrumb: [
        {name: '首页', hrefUrl: '/'},
        {name: '产品', hrefUrl: '#'},
        {name: '软件平台', hrefUrl: '/product/softwarePlatform'},
      ],
    }
  },
  methods:{
    handleClick(tab, event) {
      if (tab._props.name == "entranceGuard") {
        // 智能门禁软件
        this.$router.push("/product/softwarePlatform/entranceGuardSoftware")
      }

      if(tab._props.name == "under") {
        this.$router.push("/product/softwarePlatform/exhibitionSoftware")
      }
      if (tab._props.name == "aft") {
        this.$router.push("/product/softwarePlatform/aftTheSoftware")
      }
    }
  },
  mounted() {
    // 判断需要加载的页面
    const activeName = this.activeName;
    switch (activeName) {
      case "entranceGuard" :
        this.$router.push("/product/softwarePlatform/entranceGuardSoftware")
        break
      case "under" :
        this.$router.push("/product/softwarePlatform/exhibitionSoftware")
        break
    }
  }
}
</script>

<style scoped>

.el-tabs {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  user-select: none;

}

/deep/.el-tabs__item {
  font-size: 24px;
  padding-top: 10px;
  padding-bottom: 20px;
  font-weight: 700;
}
</style>
